import type { RSheetColumn, RSheetRecordNode } from '../column'
import { type Cell, isPlaceholderCellValue, isReferenceCellValue } from '../copyMatrix'

// 参照列へのペーストの解決方法。value（ラベル文字列）とは別に持ち、後段の検索要否を分岐する。
// undefined ⟺ 非参照列（または placeholder）
export type RelationPaste =
  | { kind: 'resolvedById'; id: string; label: string } // ID 解決済み → 検索スキップ
  | { kind: 'searchByLabel' } // 従来のラベル検索が必要

// コピーされたセルと貼り付け先カラムから、参照列ペーストの解決方法を決める（純粋関数）。
// salescoreValue が同一参照先エンティティの reference なら id 解決、そうでなければラベル検索。
export const resolveRelationPaste = (
  copiedCell: Cell,
  column: RSheetColumn<RSheetRecordNode>,
  targetReferencedStreamName: string | undefined,
): RelationPaste | undefined => {
  if (column.metaType !== 'relation' || isPlaceholderCellValue(copiedCell.value)) {
    return undefined
  }
  const reference = isReferenceCellValue(copiedCell.salescoreValue) ? copiedCell.salescoreValue : undefined
  if (
    reference !== undefined &&
    targetReferencedStreamName !== undefined &&
    reference.referencedStreamName === targetReferencedStreamName
  ) {
    return { kind: 'resolvedById', id: reference.id, label: reference.label }
  }
  return { kind: 'searchByLabel' }
}
